import React from 'react';
import styles from "./contact_form.module.css";
import { useState } from "react";
import { useConfig } from "@/context/ConfigContext";
import { useI18N } from "@/context/I18NContext";
//import Link from "next/link";
import { Form, FormActionType } from '@/components/form';
import { getContactForm } from './forms/contact/ContactForm';
import { Animation, LottieAnimation } from '@/components/animation';
import { IoCheckmarkCircleOutline, IoWarningOutline } from 'react-icons/io5';
import { useFirebase } from '@/hooks/useFirebase';
import { FirebaseModule, getAnalytics } from '@/utils/FirebaseUtils';

export interface ContactFormProps {
  suggestion? : string;
}

export const ContactForm = (props : ContactFormProps) => {
  const { t } = useI18N();
  const {
    suggestion
  } = props;

  const {
    contact,
    ...config
  } = useConfig();

  const initialData = {
    name : '',
    phone: '',
    mail : '',
    company : '',
    content : suggestion,
    terms: false
  };

  const [status, setStatus] = useState<string | null>(null);

  const {firebase} = useFirebase(config.firebase, [FirebaseModule.ANALYTICS]);

  return (
    <div className={styles.contact} id="contact">
      <h2 className={styles.contact_title}>
        {t('contact.title')}
      </h2>
      <div className={styles.contact_content}>
        <Form rows={getContactForm(initialData)} action={{
          title : 'Enviar',
          type: FormActionType.SUBMIT,
          action: (formData : object) => {
            setStatus('loading');

            fetch(contact.action, {
              method: 'post',
              headers: {
                "Content-Type": "application/json",
                // 'Content-Type': 'application/x-www-form-urlencoded',
              },
              body: JSON.stringify(formData)
            }).then(() => {
              const {
                analytics,
                logEvent
              } = getAnalytics(firebase);
            
              logEvent(analytics, "send_mail", {});

              setStatus('ok');
            }).catch((error) => {
              console.log("error", error);
              setStatus('error');
            });
          }
        }}/>
        <div className={styles.contact_content_other}>
          {Object.keys(contact.info).map((infoItem, i) => 
            <div className={styles.contact_content_other_block} key={i}>
              <div className={styles.contact_content_other_block__title}>
                {t(`contact.${infoItem}`)}
              </div>
              {typeof contact.info[infoItem] == 'object' &&
                <a className={styles.contact_content_other_block__value} href={contact.info[infoItem].link} title={contact.info[infoItem].value}>
                  {contact.info[infoItem].value}
                </a>
              }
              {typeof contact.info[infoItem] == 'string' &&
                <div className={styles.contact_content_other_block__value}>
                  {contact.info[infoItem]}
                </div>
            }
              
            </div>
          )}
        </div>
        {status &&
          <div className={styles.contact_results_form}>
            <div className={styles.contact_results_form_icon}>
              {status == 'loading' && <Animation animation={LottieAnimation.LOADING}/>}
              {status == 'ok' && <IoCheckmarkCircleOutline className={styles.contact_results_icon__success}/>}
              {status == 'error' && <IoWarningOutline className={styles.contact_results_icon__error}/>}
            </div>
            <div className={styles.contact_results_form_text}>
              {status == 'loading' && 'Estamos enviando tu solicitud'}
              {status == 'ok' && 'Hemos recibido tu solucitud, te responderemos lo antes posible. Gracias por contactar con nosotros.'}
              {status == 'error' && 'Se ha producido un error, por favor inténtalo más tarde o prueba uno de los métodos de contacto alternativos.'}
            </div>
          </div>
        }
      </div>
    </div>
  );
};
